export { default } from './FormControlLabel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/FormControlLabel/index.js
// module id = 406
// module chunks = 2